import { render } from "./EditNinatrennInfo.vue?vue&type=template&id=4ed9ccce&scoped=true"
import script from "./EditNinatrennInfo.vue?vue&type=script&lang=js"
export * from "./EditNinatrennInfo.vue?vue&type=script&lang=js"

import "./EditNinatrennInfo.vue?vue&type=style&index=0&id=4ed9ccce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed9ccce"]])

export default __exports__